import { GForceLayout } from '@antv/layout/lib/layout/gForce';

export default GForceLayout;
